(function () {
  if (window.__mxWiserText) return;
  window.__mxWiserText = true;

  var ROOTS = '.evm-recommended-products, .evm-wscontainer, .evm-ws-card, .evm-wiser-owl-carousel, [class*="evm-ws"], [class*="evm-wiser"], [class*="ws-popup"]';
  var ATTRS = ['title', 'alt'];
  var ENTITY = /&(?:[a-zA-Z][a-zA-Z0-9]{1,31}|#\d{1,7}|#[xX][0-9a-fA-F]{1,6});/;
  var TRUNCATED = /(\.\.\.|…)$/;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1 };

  var parser = new DOMParser();
  var pending = 0;

  function decode(value) {
    var out = value;
    for (var i = 0; i < 4; i++) {
      if (!ENTITY.test(out)) break;
      var doc = parser.parseFromString(out, 'text/html');
      var next = doc.documentElement ? doc.documentElement.textContent : null;
      if (next == null || next === out) break;
      out = next;
    }
    return out;
  }

  function fixNode(node) {
    var value = node.nodeValue;
    if (!value || !ENTITY.test(value)) return;
    var parent = node.parentNode;
    if (parent && SKIP_TAGS[parent.nodeName]) return;
    var decoded = decode(value);
    if (decoded !== value) node.nodeValue = decoded;
  }

  function fixAttrs(el) {
    for (var i = 0; i < ATTRS.length; i++) {
      var name = ATTRS[i];
      if (!el.hasAttribute(name)) continue;
      var value = el.getAttribute(name);
      if (!ENTITY.test(value)) continue;
      var decoded = decode(value);
      if (decoded !== value) el.setAttribute(name, decoded);
    }
  }

  function restoreTitle(card) {
    var el = card.querySelector('.ws-card__title');
    if (!el || el.childElementCount) return;

    var link = card.querySelector('.ws-card__header-link[title]');
    var full = link ? link.getAttribute('title').trim() : '';
    if (!full || ENTITY.test(full)) return;

    var text = el.textContent.trim();
    if (text === full || !TRUNCATED.test(text)) return;

    el.textContent = full;
    var thumb = card.querySelector('.ws-card_image_container[title]');
    if (thumb) thumb.setAttribute('title', full);
  }

  function walk(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) fixNode(node);

    fixAttrs(root);
    var labelled = root.querySelectorAll('[title], [alt]');
    for (var i = 0; i < labelled.length; i++) fixAttrs(labelled[i]);

    var cards = root.matches('.evm-ws-card') ? [root] : root.querySelectorAll('.evm-ws-card');
    for (var j = 0; j < cards.length; j++) restoreTitle(cards[j]);
  }

  function sweep() {
    pending = 0;
    var roots = document.querySelectorAll(ROOTS);
    for (var i = 0; i < roots.length; i++) walk(roots[i]);
  }

  function schedule() {
    if (pending) return;
    pending = setTimeout(sweep, 120);
  }

  function start() {
    sweep();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
